// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2L2tT","title":"Images45_title__2NRG3","images":"Images45_images__2I6Ed"};